export const getFigmaFileStyles = (file) => {
  const styles = Object.entries(file.styles).map(([styleId, style]) => ({
    styleId,
    ...style,
  }));
  // .filter((style) => !style.remote);

  return styles;
};
